<template>
  <b-card-body>
    <div id="ProductionPlanEditor">
      <b-form @submit.stop.prevent="salvar">
        <b-row class="rowInputAndRadio">
          <b-col class="inputGroup">
            <b-form-group label="Nome:" label-for="namePlanItem">
              <b-form-input class="input-pentagro" id="namePlanItem" type="text" name="validateName"
                v-model="planitem.name" v-validate="{ required: true, alpha_num: true }"
                :state="validateState('validateName')" aria-describedby="validateName-feedback"
                data-vv-as="nome da variável" placeholder="Informe o nome da variável ..."
                title="Campo para informar o nome da variável" alt="Campo para informar o nome da variável" />
              <b-form-invalid-feedback id="validateName-feedback">{{
                veeErrors.first("validateName")
              }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Cabeçalho:" label-for="headerPlanItem">
              <b-form-input class="input-pentagro" id="headerPlanItem" type="text" name="validateHeader"
                v-model="planitem.header" v-validate="{ required: true }" :state="validateState('validateHeader')"
                aria-describedby="validateHeader-feedback" data-vv-as="cabeçalho" placeholder="Informe o cabeçalho ..."
                title="Campo para informar a descrição da variável" alt="Campo para informar a descrição da variável" />
              <b-form-invalid-feedback id="validateHeader-feedback">{{
                veeErrors.first("validateHeader")
              }}</b-form-invalid-feedback>
            </b-form-group>

            <b-row :class="[
                  { inputGroup2: !planitem.lt, inputGroup2_1: planitem.lt },
                ]">
              <b-col>
                <b-form-group id="inputAreaItem" label="Área de processo:" label-for="areaPlanItem">
                  <b-form-input class="input-pentagro" list="areaPlanItemList" type="text" name="validatearea"
                    style="min-width: 295px" v-model="planitem.processArea" v-validate="{ required: true }"
                    :state="validateState('validatearea')" aria-describedby="validatearea-feedback"
                    data-vv-as="área de processo" placeholder="Informe a área de processo ..."
                    title="Campo para informar em qual área a variável estará"
                    alt="Campo para informar em qual área a variável estará" />
                  <b-form-invalid-feedback id="validatearea-feedback">{{
                    veeErrors.first("validatearea")
                  }}</b-form-invalid-feedback>
                  <datalist id="areaPlanItemList">
                    <option v-for="area in processAreas" :key="area">
                      {{ area }}
                    </option>
                  </datalist>
                </b-form-group>
              </b-col>

              <b-col v-if="planitem.lt">
                <b-form-group id="inputLtAreaItem" label="Área LT:" label-for="ltAreaPlanItem">
                  <b-form-input class="input-pentagro" list="ltAreaPlanItemList" type="text" name="validateltarea"
                    style="min-width: 295px" v-model="planitem.ltArea" v-validate="{
                      required: this.planitem.lt == 1 ? true : false,
                    }" :state="validateState('validateltarea')" aria-describedby="validateltarea-feedback"
                    data-vv-as="área da LT" placeholder="Informe a área na LT ..."
                    title="Campo para informar em qual área da lista técnica a variável estará"
                    alt="Campo para informar em qual área da lista técnica a variável estará" />
                  <b-form-invalid-feedback id="validatearea-feedback">{{
                    veeErrors.first("validateltarea")
                  }}</b-form-invalid-feedback>
                  <datalist id="ltAreaPlanItemList">
                    <option v-for="area in ltAreas" :key="area">
                      {{ area }}
                    </option>
                  </datalist>
                </b-form-group>
              </b-col>

              <b-col>
                <b-row class="row-units">
                  <b-col>
                    <b-form-group label="Sequência:" label-for="sequence">
                      <b-form-input class="input-pentagro" id="sequence" type="text" name="validateSequence"
                        v-model="planitem.sequence" v-validate="{ required: true }"
                        :state="validateState('validateSequence')" aria-describedby="validateSequence-feedback"
                        data-vv-as="sequencia" placeholder="Informe a sequência ..."
                        title="Campo para informar em qual sequência a variável estará"
                        alt="Campo para informar em qual sequência a variável estará" />
                      <b-form-invalid-feedback id="validateSequence-feedback">
                        {{ veeErrors.first("validateSequence") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="inputUnitItem" label="Unidade:" label-for="unitPlanItem">
                      <b-form-input class="input-pentagro" type="text" name="validateunit" v-model="planitem.unit"
                        v-validate="{ required: true }" :state="validateState('validateunit')"
                        aria-describedby="validateunit-feedback" data-vv-as="unidade" placeholder="Informe a unidade ..."
                        title="Campo para informar em qual a unidade de medida da variável"
                        alt="Campo para informar em qual a unidade de medida da variável" />
                      <b-form-invalid-feedback id="validateunit-feedback">
                        {{ veeErrors.first("validateunit") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col class="fieldDecimalPlace" v-if="planitem.productionPlan">
                    <b-form-group id="inputDecimalPlace" label="Casas Decimais:" label-for="inputDecimalPlace">
                      <b-form-input class="input-pentagro" type="number" name="validatedecimalplace"
                        v-model="planitem.decimalPlace" min="0" data-vv-as="casas decimais"
                        placeholder="Informe a quantidade de casas decimais..."
                        title="Campo para informar em quantas casas decimais a variável tera na visualização do plano de safra"
                        alt="Campo para informar em quantas casas decimais a variável tera na visualização do plano de safra" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="planitem.productionPlan">
                <b-row>
                  <b-col>
                    <b-form-group id="inputTypeOfCalcAccumulated" label="Tipo Cálculo Acumulado:"
                      label-for="typeOfCalcAccumulated">
                      <b-form-radio-group v-model="planitem.typeCalAccumulated" name="radio-typeOfCalcAccumulated">
                        <b-form-radio class="cursor-pointer" value="SOM">Soma</b-form-radio><br />
                        <b-form-radio class="cursor-pointer" value="MDS">Média Simples</b-form-radio><br />
                        <b-form-radio class="cursor-pointer" value="MDP">Média Ponderada</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row v-if="planitem.typeCalAccumulated == 'MDP'">
                  <b-col>
                    <b-form-group label="Variável de peso do acumulado:">
                      <div class="groupEquationAccumulated">
                        <b-form-input class="input-pentagro" v-model="planitem.varWeightAccumulated"
                          placeholder="Variável peso do acumulado" data-vv-as="variavel peso"
                          title="Campo para selecionar qual variável será o peso da média ponderada"
                          alt="Campo para selecionar qual variável será o peso da média ponderada" disabled>
                        </b-form-input>
                        <div id="search" @click="findVariable"></div>
                        <img v-if="planitem.varWeightAccumulated" id="eraser" class="float-right"
                          src="@/assets/apagar.png" style="margin-left: 15px; max-height: 40px" title="Limpar equação"
                          alt="Limpar equação" @click="() => {
                            planitem.varWeightAccumulated = '';
                          }
                            " />
                      </div>
                    </b-form-group>

                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col class="radioAndCheckGroup">
            <b-form-group label="Tipo:" title="Campo para selecionar qual o tipo da variável"
              alt="Campo para selecionar qual o tipo da variável">
              <b-form-radio-group v-model="planitem.type" name="radio-type">
                <b-form-radio class="cursor-pointer" value="FIN">Entrada Agrícola</b-form-radio><br />
                <b-form-radio class="cursor-pointer" value="PIN">Entrada Processo</b-form-radio><br />
                <b-form-radio class="cursor-pointer" value="OUT">Saída</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group>
              <b-form-checkbox class="cursor-pointer" value="1" v-model="planitem.productionPlan">
                Plano de Safra
              </b-form-checkbox>
              <b-form-checkbox class="cursor-pointer" value="1" v-model="planitem.lt">
                <span title="Lista técnica" alt="Lista técnica"> LT </span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="groupBtn">
          <b-col>
            <b-form-group label="Equação:">
              <div class="groupEquation">
                <b-form-input class="input-pentagro" v-model="planitem.equation" placeholder="Equação" disabled>
                </b-form-input>
                <span class="btn-form">
                  <img v-if="planitem.equation" id="eraser" class="float-right" src="@/assets/apagar.png"
                    style="margin-left: 15px; max-height: 40px" title="Limpar equação" alt="Limpar equação" @click="() => {
                      planitem.equation = '';
                    }
                      " />
                  <img id="edit-button" class="float-right" src="@/assets/editar.png"
                    style="margin-left: 15px; max-height: 35px" title="Editar equação" alt="Editar equação"
                    @click="$bvModal.show('modalProductionPlanEquationEditor')" />
                </span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="lineGroupMap">
              <b-form-group label="Mapeamento:">
                <div class="groupMap">
                  <b-form-input class="input-pentagro" v-model="planitem.mapping" placeholder="Mapeamento" disabled>
                  </b-form-input>

                  <div v-if="planitem.mapping">
                    <label>Valor:</label>
                    <b-form-input class="input-pentagro" v-model="valueMapping" placeholder="Valor" disabled>
                    </b-form-input>
                  </div>

                  <span class="btn-form">
                    <img v-if="planitem.mapping" id="eraser" class="float-right" src="@/assets/apagar.png"
                      style="margin-left: 15px; max-height: 40px" title="Limpar Mapeamento" alt="Limpar Mapeamento"
                      @click="() => {
                        planitem.mapping = '';
                        planitem.mappingType = '';
                      }
                        " />
                    <img v-if="planitem.mappingType" id="" class="float-right" src="@/assets/editar.png"
                      style="margin-left: 15px; max-height: 35px" title="Editar Mapeamento" alt="Editar Mapeamento"
                      @click="$bvModal.show('modalProductionPlanMapEditor')" />
                  </span>
                </div>
              </b-form-group>

              <b-form-radio-group class="mappingTypeRadioBt" v-model="planitem.mappingType" plain
                name="radio-group-maptype" title="Campo para selecionar o tipo do mapeamento"
                alt="Campo para selecionar o tipo do mapeamento">
                <b-form-radio class="cursor-pointer" :disabled="planitem.mapping ? true : false"
                  value="I">Entrada</b-form-radio>
                <b-form-radio class="cursor-pointer" :disabled="planitem.mapping ? true : false"
                  value="O">Saida</b-form-radio>
              </b-form-radio-group>
            </div>
          </b-col>
        </b-row>
      </b-form>

      <span class="filter-kpi" title="Filtre por nome ou cabeçalho das variáveis"
        alt="Filtre por nome ou cabeçalho das variáveis">
        <label for="filter-kpi">{{ $t('filtro') }}</label>
        <input type="text" name="filter-kpi" class="ml-1 sample1-filter-input" v-model="filter"
          placeholder="Nome ou Cabeçalho" />
      </span>

      <div class="tableSection">
        <b-row v-if="loaded">
          <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
            <table class="table table-hover table-sm">
              <thead class="thead-dark">
                <th scope="col">SEQUÊNCIA</th>
                <th scope="col">NOME</th>
                <th scope="col">CABEÇALHO</th>
                <th scope="col" style="text-align: center">UNIDADE</th>
                <th scope="col">ÁREA DE PROCESSO</th>
                <th scope="col" style="text-align: center">AÇÕES</th>
              </thead>
              <template v-if="this.filteredItensList.length == 0">Sem dados para visualização<br /></template>
              <tbody v-else>
                <tr v-for="item in this.filteredItensList" :key="item.sequence">
                  <td class="text-truncate tableTxt" style="min-width: 80px; text-overflow: ellipsis">
                    {{ item.sequence }}
                  </td>
                  <td class="text-truncate tableTxt" style="min-width: 250px; text-overflow: ellipsis">
                    {{ item.name }}
                  </td>
                  <td class="text-truncate tableTxt" style="min-width: 250px; text-overflow: ellipsis">
                    {{ item.header }}
                  </td>
                  <td class="text-truncate tableTxt" style="min-width: 100px; text-align: center">
                    {{ item.unit }}
                  </td>
                  <td class="text-truncate tableTxt" style="min-width: 200px; text-overflow: ellipsis">
                    {{ item.processArea }}
                  </td>
                  <td class="text-truncate tableTxt imgTd">
                    <img src="@/assets/upL.png" title="Subir Posição" alt="Subir Posição"
                      style="height: 15px; width: 15px" @click="upSequence(item.sequence)" />
                    <img src="@/assets/downL.png" title="Descer Posição" alt="Descer Posição"
                      style="height: 15px; width: 15px" @click="downSequence(item.sequence)" />
                    <img src="@/assets/editar.png" title="Editar Variavel" alt="Editar Variavel"
                      style="margin-left: 3px; height: 15px; width: 15px" @click="editPlanItem(item.id)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row v-else class="waitTxt rowDistance">Aguardando banco de dados ...</b-row>
      </div>

      <b-row class="groupBtn">
        <div>
          <img id="" src="@/assets/salvar.png" style="margin-left: 30px; max-height: 35px" :title="$t('salvar')"
            alt="Salvar" @click="salvar()" />
          <img v-if="user &&
            user.Permissions.excluirvariavel.allowed &&
            this.planitem.id
            " id="" src="@/assets/excluir.png" style="margin-left: 30px; max-height: 35px" title="Excluir"
            alt="Excluir" @click="deleteVariable()" />
          <img id="" src="@/assets/cancel.png" style="margin-left: 30px; max-height: 35px" :title="$t('cancelar')"
            alt="Cancelar" @click="eraseForm()" />
        </div>
      </b-row>
    </div>
    <b-modal id="modalFindVariableToAccumulated" size="lg" :title="$t('procurar-variavel')" no-close-on-backdrop
      hide-footer>
      <equation-editor :equation="planitem.varWeightAccumulated" :nameModal="modalFindVariableToAccumulated" :mdp="false"
        @finalEquation="planitem.varWeightAccumulated = $event" />
    </b-modal>

    <b-modal id="modalProductionPlanEquationEditor" size="lg" hide-footer title="EDITOR DE EQUAÇÃO">
      <equation-editor :equation="planitem.equation" :nameModal="modalProductionPlanEquationEditor" :mdp="true"
        @finalEquation="planitem.equation = $event"></equation-editor>
    </b-modal>
    <b-modal id="modalProductionPlanMapEditor" hide-footer title="EDITOR DE MAPEAMENTO">
      <map-editor @mapSelected="planitem.mapping = $event" :lastMap="planitem.mappingType"></map-editor>
    </b-modal>
    <b-modal id="modalEraseVariable" size="lg" hide-footer title="Exclusão de Variável" :no-close-on-backdrop="true">
      <EraseVariable :result="result" :name="planitem.name" />
    </b-modal>
  </b-card-body>
</template>

<script>
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import axios from "axios";

import equationEditor from "./ProductionPlanEquationEditor.vue";
import mapEditor from "./ProductionPlanMapEditor.vue";
import EraseVariable from "./EraseVariable";
import { mapState } from "vuex";

export default {
  name: "ProductionPlanEditor",

  provide() {
    return {
      getModelTreeStructure: this.getModelTreeStructure,
    };
  },

  components: { equationEditor, mapEditor, EraseVariable },

  watch: {
    filter(value) {
      if (value == "") this.filteredItensList = this.itensList;
      else
        this.filteredItensList = this.itensList.filter(
          (d) =>
            d.name.toUpperCase().includes(value.toUpperCase()) ||
            d.header.toUpperCase().includes(value.toUpperCase())
        );
    },

    "planitem.mapping"(value) {
      if (value) {
        let mapping = value.split("|");
        let dicStructure = '';

        if (mapping[0] == 'cr' || mapping[0] == 'cp') {
          dicStructure = Object.keys(this.objectStructure.Correntes)
          let map = dicStructure.find(x => x == mapping[1]);
          let chain = Object.keys(this.objectStructure.Correntes[map])

          let att = chain.find(element =>
            Object.keys(this.objectStructure.Correntes[map][element]) == mapping[2]
          );
          this.valueMapping = this.objectStructure.Correntes[map][att][mapping[2]][mapping[3]]
        } else {
          dicStructure = Object.keys(this.objectStructure.Operações);
          let proc = mapping[1] + '|' + mapping[2];

          let map = dicStructure.find(x => x == proc);
          let chain = Object.keys(this.objectStructure.Operações[map])

          let att = chain.find(element =>
            element == "Atributos"
          );
          this.valueMapping = this.objectStructure.Operações[map][att][mapping[3]];
        }
      }
    }
  },

  data() {
    return {
      modalFindVariableToAccumulated: "modalFindVariableToAccumulated",
      modalProductionPlanEquationEditor: "modalProductionPlanEquationEditor",
      optionsplanitem: false,
      optionsgroup: [],
      processAreas: [],
      ltAreas: [],
      plansafra: false,
      filter: "",
      planitem: {
        id: 0,
        name: "",
        header: "",
        allowed: 0,
        unit: "",
        sequence: "",
        processArea: "",
        ltArea: "",
        equation: "",
        mapping: "",
        type: "FIN",
        mappingType: "",
        productionPlan: 0,
        lt: 0,
        typeCalAccumulated: "SOM",
        varWeightAccumulated: "",
        decimalPlace: 0,
      },
      itensList: [],
      filteredItensList: [],
      loaded: false,
      savedStatus: false,
      xml: null,
      modelTreeStructure: {
        full: null,
        input: null,
        output: null,
      },
      result: null,
      valueMapping: null,
      objectStructure: null
    };
  },

  computed: mapState(["user"]),

  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    async getModelTreeStructure() {
      if (
        this.modelTreeStructure &&
        this.modelTreeStructure.full &&
        this.modelTreeStructure.input &&
        this.modelTreeStructure.output
      ) {
        return this.modelTreeStructure;
      }

      this.xml = this.$store.state.xml;

      if (this.xml == null) {
        let url = `${urlMainAPI}/loadactivesimulationscenario`;

        await axios
          .get(url)
          .then((res) => {
            let xml = {};
            xml.name = res.data.name;
            xml.scenario = res.data.scenario;
            xml.scenarioResult = res.data.scenarioResult;

            this.$store.commit("setXML", xml);
            localStorage.setItem("xml", JSON.stringify(xml));
          })
          .catch(console.error);
        this.xml = this.$store.state.xml;
      }

      this.loadModelTreeStructure(this.xml, "full");

      const inputObject = { name: this.xml.name, scenario: this.xml.scenario };
      this.loadModelTreeStructure(inputObject, "input");

      const outputObject = {
        name: this.xml.name,
        scenarioResult: this.xml.scenarioResult,
      };
      this.loadModelTreeStructure(outputObject, "output");

      return this.modelTreeStructure;
    },

    async loadModelTreeStructure(xml, stringFlag) {
      let mapList = this.$store.state.mapList;
      if (mapList && mapList.full && mapList.input && mapList.output) {
        this.modelTreeStructure = mapList;
        return;
      }

      let obj = {};

      obj.scenario = xml.scenario;
      obj.scenarioResult = xml.scenarioResult;
      const url = `${urlMainAPI}/getmodeltreestructure`;
      await axios
        .post(url, obj)
        .then((res) => {
          if (res) {
            if (stringFlag === "full") {
              this.modelTreeStructure.full = res.data;
            } else if (stringFlag === "input") {
              this.modelTreeStructure.input = res.data;
            } else {
              /* Output */
              this.modelTreeStructure.output = res.data;
            }
            this.$store.commit("setMapList", this.modelTreeStructure);
          }
        })
        .catch();
    },

    async loadProductioPlanItensList() {
      const url = `${urlMainAPI}/getproductionplanitemlist`;
      await axios
        .get(url)
        .then((res) => {
          this.itensList = res.data;
          this.filteredItensList = this.itensList;
          this.loaded = true;
        })
        .catch();
      this.processAreas = new Set(
        this.itensList
          .map((x) => x.processArea)
          .filter((x) => x != null)
          .sort()
      );
      this.ltAreas = new Set(
        this.itensList
          .map((x) => x.ltArea)
          .filter((x) => x != null)
          .sort()
      );
    },

    editPlanItem(id) {
      defaultSuccess(this.$t("carregando-dados-da-variavel"));
      const url = `${urlMainAPI}/getproductionplanitem/${id}`;
      axios
        .get(url)
        .then((res) => {
          this.planitem = res.data;
          this.filter = "";
        })
        .catch();
    },

    eraseForm() {
      let planitemtemp = {
        id: 0,
        name: "",
        header: "",
        allowed: 0,
        unit: "",
        sequence: 0,
        processArea: "",
        ltArea: "",
        equation: "",
        mapping: "",
        type: "FIN",
        mappingType: "",
        productionPlan: 0,
        lt: 0,
        typeCalAccumulated: "SOM",
        varWeightAccumulated: "",
        decimalPlace: 0
      };
      this.planitem = planitemtemp;
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },

    salvar() {
      this.$validator.validateAll().then(async (result) => {
        let itemConflit = this.itensList.find(
          (item) => item.sequence == this.planitem.sequence
        );
        const IsDifferent = itemConflit && itemConflit.id != this.planitem.id;

        if (IsDifferent) {
          showError(
            this.$t("sequencia") +
            `${itemConflit.sequence} ` +
            this.$t("ja-existente-item") +
            `${itemConflit.header}`
          );
          return false;
        }

        if (!result) {
          showError(this.$t("campos-com-preenchimento-obrigatorio"));
          return;
        }

        this.planitem.lt = this.planitem.lt == 1 ? 1 : 0;
        this.planitem.ltArea =
        this.planitem.lt == 1 ? this.planitem.ltArea : null;
        
        const regex01 = new RegExp(`\\b${this.planitem.name}\\b(?!\\s*[+\\-*\\/√%^])`);
        const regex02 = new RegExp(`\\b${this.planitem.name}\\b\\s*[+\\-*\\/\\%]`);

        if (regex01.test(this.planitem.equation) || regex02.test(this.planitem.equation)) {
          showError(this.$t("nao-pode-conter-a-propria-varivel-na-chamada-da-equacao"));
          return false;
        }

        const url = `${urlMainAPI}/saveproductionplanitem`;
        await axios
          .post(url, this.planitem)
          .then((res) => {
            if (res) {
              this.eraseForm();
              defaultSuccess(res.data);
              this.loadProductioPlanItensList();
            }
          })
          .catch();
      });
    },

    async saveNewSequence() {
      let obj = this.itensList.map((x) => {
        return { id: x.id, sequence: x.sequence };
      });
      const url = `${urlMainAPI}/savenewsequencelist`;
      await axios
        .post(url, obj)
        .then(() => defaultSuccess(this.$t("sequencia-alterada")))
        .catch();
    },

    upSequence(sequence) {
      let positionObj = this.itensList.findIndex(
        (obj) => obj.sequence == sequence
      );
      let antObj = positionObj - 1;

      if (antObj >= 0) {
        let positionObjSequence = this.itensList[positionObj].sequence;
        let antObjSequence = this.itensList[antObj].sequence;

        this.itensList[positionObj].sequence = antObjSequence;
        this.itensList[antObj].sequence = positionObjSequence;
        this.itensList.sort((a, b) =>
          a.sequence < b.sequence ? -1 : b.sequence > a.sequence ? 1 : 0
        );
      }
      this.saveNewSequence();
      return;
    },

    downSequence(sequence) {
      let positionObj = this.itensList.findIndex(
        (obj) => obj.sequence == sequence
      );
      let postObj = positionObj + 1;

      if (postObj < this.itensList.length) {
        let positionObjSequence = this.itensList[positionObj].sequence;
        let postObjSequence = this.itensList[postObj].sequence;

        this.itensList[positionObj].sequence = postObjSequence;
        this.itensList[postObj].sequence = positionObjSequence;
        this.itensList = this.itensList.sort((a, b) =>
          a.sequence < b.sequence ? -1 : b.sequence > a.sequence ? 1 : 0
        );
      }
      this.saveNewSequence();
      return;
    },
    async deleteVariable() {
      const url = `${urlMainAPI}/deleteproductionplanitem/${this.planitem.id}`;

      axios
        .get(url)
        .then((res) => {
          if (res && res.status === 200) {
            defaultSuccess(res.data);
            this.eraseForm();
            this.loadProductioPlanItensList();
          }
        })
        .catch((e) => {
          this.result = e.response.data;
          this.$bvModal.show("modalEraseVariable");
        });
    },

    findVariable() {
      this.$bvModal.show("modalFindVariableToAccumulated");
    },

    getMappingXml() {
      let xml = localStorage.getItem("xml") ? JSON.parse(localStorage.getItem("xml")) : { scenarioObjectStructure: '' };
      this.objectStructure = xml.scenarioObjectStructure;
    },
  },

  created() {
    this.$validator.localize("pt_BR");
    this.loadProductioPlanItensList();
    this.getModelTreeStructure();
    setTimeout(() => {
      this.getMappingXml();
    }, 3000);
  },
};
</script>

<style>
.cursor-pointer>label {
  cursor: pointer;
}
</style>

<style scoped>
#modalProductionPlanEquationEditor {
  size: lg;
}

.inputText {
  max-width: 851px;
  min-width: 300px;
}

table {
  border-collapse: initial;
  border-spacing: initial;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.groupBtn img {
  cursor: pointer;
}

.groupEquation {
  display: flex;
  flex-wrap: nowrap;
}

.groupEquationAccumulated {
  display: flex;
  flex-wrap: nowrap;
  max-width: 43% !important;
}

.groupMap {
  display: flex;
  flex-wrap: nowrap;
}

.groupMap>div {
  margin-left: 1.5rem;
  margin-top: -1.5rem;
  margin-bottom: 1em;
}

.groupMap>div>label {
  margin-bottom: 0;
}

.btn-form {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.my-custom-scrollbar {
  max-height: 260px;
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;
}

.rowDistance {
  margin-top: 20px;
}

.tableSection {
  margin: 15px;
}

.imgTd {
  min-width: 100px;
  text-align: center;
  cursor: pointer;
}

.lineGroupMap {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  align-items: center;
  width: 100%;
}

.mappingTypeRadioBt {
  margin-top: 15px;
  margin-left: 20px;
}

img.float-right {
  cursor: pointer;
}

.inputGroup {
  display: grid;
  grid-template-rows: auto auto auto;
}

.inputGroup2 {
  display: grid;
  grid-template-columns: auto auto;
}

.inputGroup2_1 {
  display: grid;
  grid-template-columns: auto auto auto;
}

.rowInputAndRadio {
  display: grid;
  grid-template-columns: 2fr 0.8fr;
}

#inputUnitItem {
  min-width: 150px;
}

#inputAreaItem {
  min-width: 295px;
}


.fieldDecimalPlace {
  display: flex;
  justify-content: flex-end;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 5px;
}

#inputTypeOfCalcAccumulated div[role="radiogroup"] {
  display: flex;
}

.icon-find-variable {
  color: #ff5f00;
}

#search {
  float: left;
  margin: 3px 0px 0px -35px;
  cursor: pointer;
}

#search:after {
  font-family: FontAwesome;
  font-size: 20px;
  content: "\f002";
  color: #ff5f00;
}

@media only screen and (max-width: 1395px) {
  .inputGroup2_1 {
    grid-template-columns: auto;
    grid-template-rows: auto auto auto auto;
  }
}

@media only screen and (max-width: 1020px) {
  .inputGroup2 {
    grid-template-columns: auto;
    grid-template-rows: auto auto;
  }
}

@media only screen and (max-width: 540px) {
  .rowInputAndRadio {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .row.row-units {
    min-width: 300px;
    padding: 0 30px 0 0;
  }
}
</style>
